<template>
  <section class="flex">
    <section class="common-sub-top container">
      <section class="top-info-wrap">
        <div class="prev-wrap">
          <a @click="pageBefore()" class="prev"></a>
          <span class="name">설정</span>
        </div>
      </section>
    </section>
    <section class="content">
      <div>
        <div class="li">
          <span><a href="/file/penchart_menual.pdf" target="_blank">펜차트 가이드 매뉴얼</a></span>
        </div>
      </div>
      <div>
        <div class="li" @click="popup">
          <span>IP 재설정</span>
          <span>{{ ip }}:{{ port }}</span>
        </div>
        <div class="li" @click="moveLicense">
          <span>라이선스 현황</span>
          <span>{{ currentLicense }}</span>
        </div>
        <div class="li" @click="moveQuestion">
          <span>문진표 설정</span>
          <span></span>
        </div>
        <div class="li" @click="moveSortForm">
          <span>서식지 정렬 기준</span>
          <span></span>
        </div>
        <div class="li memo">
          <span>접수 메모 표시</span>
          <div>
            <input type="checkbox" id="memo" />
            <label for="memo"></label>
          </div>
        </div>
        <div class="li memo">
          <span>특이사항 표시</span>
          <div>
            <input type="checkbox" id="opdMemo" />
            <label for="opdMemo"></label>
          </div>
        </div>
        <div class="li memo">
          <span>[대기환자 목록] 처방 아이콘 표시 여부</span>
          <div>
            <input type="checkbox" id="prescriptionYn" />
            <label for="prescriptionYn"></label>
          </div>
        </div>
        <div class="li memo">
          <span>[대기환자 목록] 접수정보 표시 여부</span>
          <div>
            <input type="checkbox" id="receiptInfoViewYn" />
            <label for="receiptInfoViewYn"></label>
          </div>
        </div>
        <div class="li" @click="moveLayOutSet">
          <span>화면[가로,세로] 모드 설정</span>
          <span></span>
        </div>

        <!-- <div class="li" @click="clickPdfDownload()">
					<span>PDF TEST</span>
					<span><a href="../../file/test.pdf" target="_blank">다운로드</a></span>
				</div> -->
        <template v-if="this.$store.state.debugModeFlag === true">
          <div class="li" @click="clickDeviceInfo()">
            <span>디바이스 정보</span>
            <span></span>
          </div>
          <div class="li" @click="devicePopup">
            <span>웹 URL 설정</span>
            <span></span>
          </div>
        </template>
      </div>
    </section>
  </section>
</template>

<script>
import $ from 'jquery';

export default {
  data() {
    return {
      ip: this.$store.state.deviceInfo.ip,
      port: this.$store.state.deviceInfo.port,
      currentLicense: this.$store.state.settingInfo.licenseType == '1' ? 'Lite' : 'Pro'
    };
  },
  mounted() {
    window.receiveDeviceInfo = this.receiveDeviceInfo;
    if (this.$store.state.settingInfo.memoViewYn === 'Y') {
      $('input:checkbox[id=memo]').prop('checked', true);
    }

    if (this.$store.state.settingInfo.opdMemoViewYn === 'Y') {
      $('input:checkbox[id=opdMemo]').prop('checked', true);
    }

    if (this.$store.state.settingInfo.prescriptionYn === 'Y') {
      $('input:checkbox[id=prescriptionYn]').prop('checked', true);
    }

    if (this.$store.state.settingInfo.receiptInfoViewYn === 'Y') {
      $('input:checkbox[id=receiptInfoViewYn]').prop('checked', true);
    }



    $('#memo').click((e) => {
      let memoViewYn = $('#memo').is(':checked') === true ? 'Y' : 'N';
      //옵션 저장 정보
      let json = JSON.stringify({
        memoViewYn: memoViewYn
      });
      this.$util.setOption(json);
    });

    $('#opdMemo').click((e) => {
      let opdMemoViewYn = $('#opdMemo').is(':checked') === true ? 'Y' : 'N';

      //옵션 저장 정보
      let json = JSON.stringify({
        opdMemoViewYn: opdMemoViewYn
      });
      this.$util.setOption(json);
    });

    //처방 아이콘 표시
    $('#prescriptionYn').click((e) => {
      let prescriptionYn = $('#prescriptionYn').is(':checked') === true ? 'Y' : 'N';

      //옵션 저장 정보
      let json = JSON.stringify({
        prescriptionYn: prescriptionYn
      });
      this.$util.setOption(json);
    });

    $('#receiptInfoViewYn').click((e) => {
      let receiptInfoViewYn = $('#receiptInfoViewYn').is(':checked') === true ? 'Y' : 'N';

      //옵션 저장 정보
      let json = JSON.stringify({
        receiptInfoViewYn: receiptInfoViewYn
      });
      this.$util.setOption(json);
    });

  },
  methods: {
    pageBefore() {
      this.$router.push({
        name: '대기리스트'
      });
    },
    popup() {
      // 	popOpenAndScrollNone('#dimIPSetting .dim-popup-mark', '#dimIPSetting .dim-popup-content');
      try {
        var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
        if (varUA.match('android') != null) {
          window.penchart.callChangeAddress();
        } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
          //IOS 일때 처리
          window.webkit.messageHandlers.callChangeAddress.postMessage('');
        }
      } catch (e) {
        alert(e);
      }
    },
    receiveDeviceInfo(json) {
      try {
        //디바이스 정보로 얻은것 api 도메인 세팅
        let url = `http://${json.ip}:${json.port}`;
        this.$axios.defaults.baseURL = url;
        this.$store.state.apiDomain = url;
        this.$store.commit('deviceInfo', json);
        this.ip = json.ip;
        this.port = json.port;

        this.$router
          .push({
            name: '설정'
          })
          .catch((e) => {
            console.log(e);
          });
      } catch (e) {
        alert(e);
        console.log(e);
      }
    },
    moveLicense() {
      this.$router.push({
        name: '라이선스설정',
        params: {
          currentLicense: this.currentLicense
        }
      });
    },
    moveQuestion() {
      this.$router.push({
        name: '문진표설정',
        params: {}
      });
    },
    moveSortForm() {
      this.$router.push({
        name: '서식지정렬기준',
        params: {}
      });
    },
    clickDeviceInfo() {
      this.$router.push({
        name: '디바이스정보'
      });
    },
    moveLayOutSet() {
      this.$router.push({
        name: '화면모드설정'
      });
    },
    // IP 재설정 팝업에 넘겨줄 함수,
    // parentEvent(ip, port) {
    // 	this.ip = ip;
    // 	this.port = port;

    // 	//옵션 저장 정보
    // 	let json = JSON.stringify({
    // 		licenseType: this.$store.state.settingInfo.licenseType,
    // 		chkHosp: this.$store.state.settingInfo.chkHosp,
    // 		chkNat: this.$store.state.settingInfo.chkNat,
    // 		chkPsy: this.$store.state.settingInfo.chkPsy,
    // 		chkChild: this.$store.state.settingInfo.chkChild,
    // 		memoViewYn: this.$store.state.settingInfo.memoViewYn
    // 	});
    // 	this.$store.commit('settingInfo', json);
    // 	this.$util.setOption(json);
    // },
    devicePopup() {
      try {
        var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
        if (varUA.match('android') != null) {
          window.penchart.callChangeWebUrl();
        } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
          //IOS 일때 처리
          window.webkit.messageHandlers.callChangeWebUrl.postMessage('');
        }
      } catch (e) {
        //alert(e);
      }
    }
  }
};
</script>

<style scoped src="../../assets/css/setting.css"></style>
